<template>
	<article class="iv2-article">
		<transition mode="out-in" :name="animation">
			<div v-if="pageActive">
				<Error403 v-if="items.status == 0" />

				<Maintenance v-else-if="items.status == 2" />

				<div v-else-if="items.status == 1">
					<LayoutTitle :items="items" />
					<LayoutPattern :items="items" />
				</div>
			</div>
		</transition>

		<div v-if="loading">
			<BaseLoading />
		</div>
	</article>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Error403 from "@/components/system/Page403.vue";
import Maintenance from "@/components/system/PageMaintenance.vue";

import Meta from "@/mixins/MetaSettable";
import Hash from "@/mixins/AnchorLink";

export default {
	mixins: [Meta, Hash],

	props: ["animation"],

	components: {
		LayoutTitle,
		LayoutPattern,
		BaseLoading,
		Error403,
		Maintenance,
	},

	data() {
		return {
			items: [],
			pageActive: false,
			loading: true,
		};
	},

	created() {
		this.axios
			.get("/json" + (this.$route.path + ".json"))
			.then((response) => {
				this.items = response.data.page;
				this.loading = false;
				this.pageActive = true;
			});
	},

	watch: {
		$route: function (to, from) {
			if (to.path !== from.path) {
				this.pageActive = false;
				this.loading = true;
				this.axios
					.get("/json" + (this.$route.path + ".json"))
					.then((response) => {
						this.items = response.data.page;
						this.loading = false;
					});
			}
			setTimeout(() => {
				this.pageActive = true;
			}, 500);
		},
	},
};
</script>

<style lang="scss">
</style>
